import React, { useCallback, useState } from "react";
import {
  FaDatabase,
  FaMagnifyingGlass,
  FaSort,
  FaXmark,
} from "react-icons/fa6";
import { useGetDatasourceQuery } from "../../../dataSource/sql/TablesourceApiSlice";
import { useGetSearchDataSourcesQuery } from "../../../dataSource/generalApiSlice";
import { debounce } from "lodash";
import { FaRegCheckCircle } from "react-icons/fa";
import { RiAdminFill } from "react-icons/ri";
import { format } from "date-fns";
import {
  CreateSheet,
  getWorkbookProperty,
  setWorkbookProperty,
} from "../../WorkbookSlice";
import { useSelector, useDispatch } from "react-redux";
import LoadingIndicator from "../../../../components/BasicComponents/LoadingIndicator";
import useAuth from "../../../../hooks/useAuth";

export default function AddNewDataSource({ closeModal }) {
  const { username } = useAuth();
  const [selectedRow, setSelectedRow] = useState(null);
  console.log(selectedRow);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  let tableBody;
  const [check, setCheck] = useState(null);
  const dataSourcesArray = useSelector((state) =>
    getWorkbookProperty(state, "dataSources")
  );
  const dispatch = useDispatch();
  const {
    data: searchedData,
    isLoading: isSearchLoading,
    isSuccess: isSearchSuccess,
    isError: isSearchError,
    error: searchError,
    refetch,
  } = useGetSearchDataSourcesQuery(
    { value: debouncedSearchTerm },
    {
      skip: !debouncedSearchTerm,
    }
  );
  const {
    data: dataSets,
    isLoading: isDataSetsLoading,
    isError: isDataSetsError,
    error: dataSetsError,
    isSuccess: isDataSetsSuccess,
  } = useGetDatasourceQuery();
  const debouncedSetSearchTerm = useCallback(
    debounce((value) => setDebouncedSearchTerm(value), 300),
    []
  );
  const handleSearchColumn = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSetSearchTerm(value);
  };
  let items = debouncedSearchTerm && searchedData ? searchedData : dataSets;
  console.log(items);
  const localDataSources = [
    ...items.filter((dItem) =>
      ["67c6d45234a9249ad0a4e131", "6720aafb500033fe2a8695de"].includes(
        dItem.id
      )
    ),
    ...items.filter((dItem) => dItem.Owner === username),
  ];
  items = localDataSources;

  if (isDataSetsLoading || isSearchLoading) {
    tableBody = <LoadingIndicator />;
  }
  if (isDataSetsError) {
    tableBody = (
      <tbody className="text-red-500 font-medium">{dataSetsError}</tbody>
    );
  }
  if (isSearchError) {
    tableBody = (
      <tbody className="text-red-500 font-medium">{searchError}</tbody>
    );
  }
  if (isDataSetsSuccess) {
    tableBody = (
      <tbody className="overflow-hidden overflow-y-auto h-60 w-full">
        {items.map((dSet, index) => {
          return (
            <tr
              key={index}
              className={`cursor-pointer flex justify-between w-full rounded gap-y-4 border mb-[2px] pl-[3.5%]
            ${
              selectedRow === index
                ? "bg-blue-950 text-white"
                : index % 2 === 0
                ? "bg-none text-black"
                : "bg-gray-100"
            } 
          `}
              onClick={() => setSelectedRow(index)}
            >
              <td className="truncate text-left border-none w-1/4 ">
                {dSet.NickName}
              </td>
              <td className="truncate text-left border-none w-1/4 ">
                {dSet.DataBaseName}
              </td>
              <td className="truncate text-left border-none w-1/4 ">
                {dSet.Owner}
              </td>
              <td className="truncate text-left border-none w-1/4 ">
                {dSet.AddedOn
                  ? format(new Date(dSet.AddedOn), "MMMM dd, yyyy h:mm a")
                  : ""}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  }
  console.log(dataSourcesArray);

  const handleDataSet = (selectedRow) => {
    const selectedDataSet = items[selectedRow].id;
    const isDataSetPresent = dataSourcesArray.includes(selectedDataSet);
    console.log(isDataSetPresent);

    if (isDataSetPresent) {
      console.log("Dataset is already present");
      setCheck("this data set is already in use");
    } else {
      const newDataSourcesArray = [...dataSourcesArray, selectedDataSet];
      console.log(newDataSourcesArray);
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key: "dataSources",
          value: newDataSourcesArray,
        })
      );
      // this will create a new sheet with new dataDourceID
      dispatch(
        CreateSheet({
          isDataSourceChanging: true,
          Action: "CreateSheet",
          newDataSourceID: selectedDataSet,
        })
      );
      closeModal();
    }
  };
  console.log(check);
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleDataSet(selectedRow); // Call your function here
    }
  };

  return (
    <main
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      <main
        className={`flex flex-col bg-white shadow-2xl rounded w-full max-w-[58rem] justify-between items-center h-auto gap-2`}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg font-medium">
          Connect to New Data
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="w-full flex flex-col px-2 gap-2 h-auto">
          <div className="w-full flex flex-col gap-y-1">
            <h2 className="w-full text-left text-base font-medium">
              Saved Data Sources
            </h2>
            <div className="flex items-center justify-start w-full relative -left-[1.5%]">
              <FaMagnifyingGlass className="relative left-5 text-md text-gray-100" />
              <input
                type="text"
                placeholder="search the data sources..."
                onChange={handleSearchColumn}
                value={searchTerm}
                className="w-full border-2 rounded pl-5 pr-2  text-black outline-none"
              />
            </div>
          </div>
          <table
            className={`border-t border-b w-full rounded border-gray-900 flex flex-col overflow-x-auto`}
          >
            <thead className="flex items-center justify-between w-full border-b-2 px-2 bg-gray-100">
              <th className="flex gap-2 items-center font-medium  w-1/4 text-left">
                <FaRegCheckCircle />
                NickName
              </th>
              <th className=" flex gap-2 items-center font-medium  w-1/4 text-left">
                <FaDatabase />
                DataBaseName
              </th>
              <th className=" flex gap-2 items-center font-medium  w-1/4 text-left">
                <RiAdminFill />
                Owner
              </th>
              <th className=" flex gap-2 items-center font-medium  w-1/4 text-left">
                <FaSort />
                AddedOn
              </th>
            </thead>
            {tableBody}
          </table>
        </section>
        <footer className="flex justify-end items-center w-full p-2 bg-gray-50 gap-x-2">
          {check !== null ? (
            <span className="font-medium text-red-500">{check}</span>
          ) : null}
          <button
            className="border py-1 px-2 tracking-wide text-gray-700 hover:bg-gray-100"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className={`border py-1 px-2 tracking-wide text-white ${
              selectedRow === null ? "bg-gray-500" : "bg-blue-950"
            }`}
            disabled={selectedRow === null}
            onClick={() => handleDataSet(selectedRow)}
          >
            Add
          </button>
        </footer>
      </main>
    </main>
  );
}
